import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputHtmlTextSF from '../../../widgets/form/InputHtmlTextSF';
import './MessageUpdateModal.css';

const MessageUpdateModalUI = ({
  context, successMsg, errorList, setErrorList, submitted,
  messageUpdateMode, onSubmit, onCancelClick,
  messageContent, onMessageContentChange, messageContentError, setMessageContentError,
}) => {
  // Toolbar buttons default to type="submit" inside a form, which triggers onSubmit.
  // Runs in the capture phase, before the browser's submit action, and doesn't stop the toolbar's own handlers.
  const preventToolbarSubmit = (e) => {
    const btn = e.target && e.target.closest ? e.target.closest('button') : null;
    if (btn && btn.getAttribute('type') !== 'button') {
      btn.setAttribute('type', 'button');
    }
  };

  // Enter inside toolbar inputs (e.g. the font size box) would submit the form
  const preventEnterSubmit = (e) => {
    if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') {
      e.preventDefault();
    }
  };

  return (
    <ModalFormUI
      context={context}
      titleLabel='Update message'
      buttonLabel="Update"
      cancelLabel="Cancel"
      isOpen={messageUpdateMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <div
        className='msg_editor_wrap'
        onClickCapture={preventToolbarSubmit}
        onKeyDown={preventEnterSubmit}
      >
        <InputHtmlTextSF
          type="html"
          name="messageContent"
          label=""
          height="100%"
          withToolbar={true}
          required={true}
          value={messageContent}
          onChange={onMessageContentChange}
          error={messageContentError}
          setError={setMessageContentError}
        />
      </div>
    </ModalFormUI>
  );
};

export default MessageUpdateModalUI;